import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";
import { getFormLayout, uuid } from "@/utils";
import { useKeyPress } from "ahooks";
import { Form, FormInstance, Input, Modal } from "antd";
import React, { useEffect } from "react";
import InputNumber from "@/components/InputNumber";
import { ManualOrderItem } from "./OrderItemForm/type";
const [formItemLayout] = getFormLayout(4);
interface AddOrUpdateOrderItemFormProps {
    form: FormInstance<ManualOrderItem>;
    autoFocus?: string;
}
const AddOrUpdateOrderItemForm: React.FC<AddOrUpdateOrderItemFormProps> = React.memo((props) => {
    const { autoFocus = "title" } = props;
    const { form } = props;

    function productValidator() {
        const { title, skuExternalId, skuProperties, productExternalId } = form.getFieldsValue();

        if (!title && !skuExternalId && !skuProperties && !productExternalId) {
            return Promise.reject("请至少填写商品名称、销售属性、商家编码或sku编码中的一项");
        }

        return Promise.resolve();
    }

    function getProductDependencies(self: string) {
        const fields = ["skuExternalId", "skuProperties", "productExternalId", "title"];

        const index = fields.indexOf(self);
        return fields.slice(index + 1);
    }

    const initialValues = { quantity: 1, price: 0 };
    return (
        <Form {...formItemLayout} form={form} initialValues={initialValues}>
            <Form.Item
                label="商品名称"
                name="title"
                rules={[{ validator: productValidator }]}
                dependencies={getProductDependencies("title")}
            >
                <Input autoFocus={autoFocus === "title"} />
            </Form.Item>

            <Form.Item label="商品简称" name="simpleTitle">
                <Input autoFocus={autoFocus === "simpleTitle"} />
            </Form.Item>

            <Form.Item
                label="销售属性"
                name="skuProperties"
                rules={[{ validator: productValidator }]}
                dependencies={getProductDependencies("skuProperties")}
            >
                <Input autoFocus={autoFocus === "skuProperties"} maxLength={256} />
            </Form.Item>
            <Form.Item
                label="商品编码"
                name="productExternalId"
                rules={[{ validator: productValidator }]}
                dependencies={getProductDependencies("productExternalId")}
            >
                <Input autoFocus={autoFocus === "productExternalId"} />
            </Form.Item>
            <Form.Item
                label="sku编码"
                name="skuExternalId"
                rules={[{ validator: productValidator }]}
                dependencies={getProductDependencies("skuExternalId")}
            >
                <Input autoFocus={autoFocus === "skuExternalId"} />
            </Form.Item>

            <Form.Item label="图片链接" name="picture">
                <Input autoFocus={autoFocus === "picture"} />
            </Form.Item>
            <Form.Item label="重量" name="weight">
                <InputNumber autoFocus={autoFocus === "weight"} min={0} suffix="kg" />
            </Form.Item>
            <Form.Item
                label="单价"
                name="price"
                rules={[
                    {
                        required: true,
                        message: "单价不能为空",
                    },
                ]}
            >
                <InputNumber autoFocus={autoFocus === "price"} min={0} precision={2} suffix="元" />
            </Form.Item>
            <Form.Item label="数量" name="quantity">
                <InputNumber autoFocus={autoFocus === "quantity"} min={1} precision={0} />
            </Form.Item>
        </Form>
    );
});

interface AddOrderItemModalProps extends InjectBaseModalProps {
    onChange?(values: ManualOrderItem[]): void;
    autoFocus?: string;
    manualProduct?: ManualOrderItem;
    onUpdate?: (manualProduct: ManualOrderItem) => void;
}

const AddOrUpdateOrderItemModal: React.FC<AddOrderItemModalProps> = function (props) {
    const { open, onCancel, manualProduct, autoFocus, onUpdate } = props;
    const [form] = Form.useForm<ManualOrderItem>();
    const onOk = async () => {
        const value = await form.validateFields();

        if (manualProduct) {
            /**
             * 复制原始对象并与表单值合并，
             * 以保留原数据中未在表单中出现的字段
             */
            const newOrderItem = { ...manualProduct, ...value };
            newOrderItem.key = manualProduct.key;
            onUpdate(newOrderItem);
        } else {
            value.key = uuid();
            props.onChange?.([value]);
        }
        onCancel();
    };
    useEffect(() => {
        if (manualProduct) {
            form.setFieldsValue({
                title: manualProduct.title,
                quantity: manualProduct.quantity,
                price: manualProduct.price,
                skuProperties: manualProduct.skuProperties,
                skuExternalId: manualProduct.skuExternalId,
                picture: manualProduct.picture,
                weight: manualProduct.weight,
                productExternalId: manualProduct.productExternalId,
                simpleTitle: manualProduct.simpleTitle,
            });
        }
    }, []);
    useKeyPress("Enter", onOk);
    return (
        <Modal
            width={580}
            open={open}
            mask={{ closable: false }}
            title={manualProduct ? "修改商品" : "添加商品"}
            onOk={onOk}
            onCancel={onCancel}
            zIndex={1031}
        >
            <AddOrUpdateOrderItemForm form={form} autoFocus={autoFocus} />
        </Modal>
    );
};
export default React.memo(AddOrUpdateOrderItemModal);
